import { VisionHeatmap } from '../../map/heatmap';
import { VisionApplication } from '../../application';
import { VisionMap } from '../../map/map';
import { VisionSweapingTab } from './sweaper';

export class SweapingMap {
    identifier = '1e874337-9029-4f66-bc51-a202ebda5b80';
    parent: VisionSweapingTab;
    map!: VisionMap;

    public heatmap!: VisionHeatmap;

    constructor(parent: VisionSweapingTab) {
        this.parent = parent;

        this.parent.tabbar.cells('map').attachHTMLString('<div id="sweaper_map_id" style="width:100%;height:100%"></div>');

        this.map = new VisionMap('sweaper_map_id');

        this.map.init('sweaper_map_id', this.parent.app.organizationService.dto?.latitude, this.parent.app.organizationService.dto?.longitude).then(() => {
            const map = this.map.map;
            this.heatmap = new VisionHeatmap(map);
            VisionApplication.getInstance().setMapWorkspace(map);
            google.maps.event.addListener(this.map.map, 'idle', () => {
                this.parent.mapIdle();
            });
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public setData(heatData: any[]) {
        this.heatmap.setHeatmapData(heatData);
        this.heatmap.createHeatmapLayer();
        this.heatmap.setProps();
    }
}
